import { render, staticRenderFns } from "./insuranceModel.vue?vue&type=template&id=d4ebcd46&scoped=true&"
import script from "./insuranceModel.vue?vue&type=script&lang=js&"
export * from "./insuranceModel.vue?vue&type=script&lang=js&"
import style0 from "./insuranceModel.vue?vue&type=style&index=0&lang=less&"
import style1 from "./insuranceModel.vue?vue&type=style&index=1&id=d4ebcd46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebcd46",
  null
  
)

export default component.exports